import React from 'react'
import { Grid, Button, Checkbox, FormControlLabel } from '@mui/material'
import CustomTextField from '../../components/CustomTextField';
import CustomInputRange from '../../components/CustomTextField/customInputRange';
import { makeStyles } from '@mui/styles';
import DateRangePicker from '../../components/DateRangePicker';

const useStyles = makeStyles(() => ({
    formLabel: {
        fontWeight: `${600} !important`,
        color: '#5563BE',
        fontSize: '16px'
    }
}));

const ImageSearchQueryParams = ({ handleSearch, searchQuery, handleChange, handleClearSearch }) => {
    const classes = useStyles()
    return <>
        <Grid container sx={{ padding: '0px 32px' }}>
            <Grid container spacing={2} sx={{ marginTop: '16px' }}>
                <Grid container spacing={2}>
                    <Grid item size={3}>
                        <CustomTextField labelText={"Account Number"}
                            textValue={searchQuery['accountNumber']}
                            handleChange={handleChange} labelName={'accountNumber'} />
                    </Grid>
                    <Grid item size={3}>
                        <CustomTextField labelText={"Lockbox Number"}
                            textValue={searchQuery['lockboxNumber']}
                            handleChange={handleChange} labelName={'lockboxNumber'} />
                    </Grid>
                    <Grid item size={3}>
                        <CustomTextField labelText={"Lockbox Site"}
                            textValue={searchQuery['lockboxSite']}
                            handleChange={handleChange} labelName={'lockboxSite'} />
                    </Grid>
                    <Grid item size={3}>
                        <CustomTextField labelText={"ABA/RT"}
                            textValue={searchQuery['abaRoutingNumber']}
                            handleChange={handleChange} labelName={'abaRoutingNumber'} />
                    </Grid>
                    <Grid item size={3}>
                        <CustomInputRange labelText={"Batch Number Range"} handleChange={handleChange}
                            fromLabelName={"batchNumberFrom"} toLabelName={"batchNumberTo"} fromTextValue={searchQuery['batchNumberFrom']}
                            toTextValue={searchQuery['batchNumberTo']} />
                    </Grid>
                    <Grid item size={3}>
                        <CustomInputRange labelText={"Batch Amount Range"} handleChange={handleChange}
                            fromLabelName={"batchAmountFrom"} toLabelName={"batchAmountTo"} fromTextValue={searchQuery['batchAmountFrom']}
                            toTextValue={searchQuery['batchAmountTo']} />
                    </Grid>
                    <Grid item size={3}>
                        <CustomInputRange labelText={"Check Number Range"} handleChange={handleChange}
                            fromLabelName={"checkNumberFrom"} toLabelName={"checkNumberTo"} fromTextValue={searchQuery['checkNumberFrom']}
                            toTextValue={searchQuery['checkNumberTo']} />
                    </Grid>
                    <Grid item size={3}>
                        <CustomInputRange labelText={"Amount Range"} handleChange={handleChange}
                            fromLabelName={"amountFrom"} toLabelName={"amountTo"} fromTextValue={searchQuery['amountFrom']}
                            toTextValue={searchQuery['amountTo']} />
                    </Grid>

                    <Grid item size={3}>
                        <CustomTextField labelText={"Checking Amount Number"}
                            textValue={searchQuery['checkingAccountNumber']}
                            handleChange={handleChange} labelName={'checkingAccountNumber'} />
                    </Grid>
                    <Grid item size={3}>
                        <CustomTextField labelText={"Customer Identifier"}
                            textValue={searchQuery['customerIdentifier']}
                            handleChange={handleChange} labelName={'customerIdentifier'} />
                    </Grid>
                    <Grid item size={3}>
                        <CustomTextField labelText={"Payee Name"}
                            textValue={searchQuery['payeeName']}
                            handleChange={handleChange} labelName={'payeeName'} />
                    </Grid>
                    <Grid item size={3}>
                        <CustomTextField labelText={"Invoice number"}
                            textValue={searchQuery['invoiceNumber']}
                            handleChange={handleChange} labelName={'invoiceNumber'} />
                    </Grid>

                    <Grid item size={5}>
                        <DateRangePicker onChange={handleChange} />
                    </Grid>
                    <Grid item size={12} sx={{ marginBottom: '16px' }}>
                        <FormControlLabel classes={{ label: classes.formLabel }} control={
                            <Checkbox
                                // checked={checked}
                                // onChange={handleChange}
                                sx={{ color: '#9E9E9E' }}
                            />
                        } label="Manage default search options" />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ boxShadow: '0px -1px 4px 0px rgba(0, 0, 0, 0.25)', justifyContent: 'flex-end', padding: '13px 32px' }}>
            {/*<Grid item >*/}
            {/*    <Button variant='outlined' sx={{ borderRadius: '24px', color: '#008CE6', fontSize: '12px' }}>View Transaction Details</Button>*/}
            {/*</Grid>*/}
            {/*<Grid item >*/}
            {/*    <Button variant='outlined' sx={{ borderRadius: '24px', color: '#008CE6', fontSize: '12px' }}>View Batch Details</Button>*/}
            {/*</Grid>*/}
            <Grid item >
                <Button variant='outlined' onClick={handleClearSearch} sx={{ borderRadius: '24px', color: '#008CE6', fontSize: '12px' }}>Clear All</Button>
            </Grid>
            <Grid item>
                <Button variant='contained' onClick={handleSearch} sx={{ borderRadius: '24px', background: '#008CE6', fontSize: '12px' }}>Search</Button>
            </Grid>

        </Grid>
    </>
}

export default ImageSearchQueryParams